/* eslint-disable */ 

import React, { useEffect } from 'react'
import { AppContent, AppSidebar, AppFooter, AppHeader } from '../components/index'

import { useAuthState } from "react-firebase-hooks/auth"
import { auth } from '../firebase'

import { useHistory } from 'react-router-dom'

const DefaultLayout = () => {

  const [user, loading, error] = useAuthState(auth)
  const history = useHistory() 

  // checks whether user is logged in or not and if not then redirects to login
  useEffect(() => {
    if (loading) return;
    if (!user) return history.push('/login');

  });

  return (
    <div>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <AppContent />
        </div>
        <AppFooter />
      </div>
    </div>
  )
}

export default DefaultLayout
